/* eslint-disable */
import { Modal, Table, Flex, Dropdown, message, Tag, Tooltip } from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";

import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import {
  MenuOutlined,
  SolutionOutlined,
  EditOutlined,
  ToolOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./index.css";
import commonFn from "@/utils/commonFn";
import { debounce } from "lodash";
import PswModal from "./PswModal";
import AddModal from "./AddModal";
import RoleModal from "./RoleModal";
import UpdateModal from "./UpdateModal";
const MainTable = forwardRef((props, ref) => {
  const [selectionType] = useState("checkbox");
  const [tableList, setTableList] = useState([]); // 表格数据
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // 筛选后的数据
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const initialTableHead = {
    email: null,
    active: null,
    enableApp: null,
    allname: null,
    roleName: null,
    companyName: null,
    ownerName: null,
    trustName: null,
    groupName: null,
    propName: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const paginationRef = useRef(pagination);
  const tableHeadRef = useRef(tableHead);
  const navigate = useNavigate();
  const pswModalRef = useRef();
  const addModalRef = useRef();
  const roleModalRef = useRef();
  const updateModalRef = useRef();

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false } // 如果列的 key 在 checkedValues 中，显示该列
              : { ...col, hidden: true }, // 否则隐藏该列
        );
      });
    },

    newListFun: () => {
      //刷新列表
      setTableHead(initialTableHead);
      getTableListFn(1, 25, initialTableHead);
    },
    showModalAdd: () => {
      addModalRef.current?.setModelAdd();
    },
  }));

  const handlePressActive = (value) => {
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, active: value };
      getTableListFn(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };

  // 定义列，包括输入框
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("PasswordReset") ||
          commonFn.btnAuthorityFlag("View/EditAccount") ||
          commonFn.btnAuthorityFlag("View/EditRole")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("PasswordReset") && {
                  key: "reset",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Password Reset</div>,
                },
                commonFn.btnAuthorityFlag("View/EditAccount") && {
                  key: "update",
                  icon: (
                    <SolutionOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>View/Edit Account</div>,
                },
                commonFn.btnAuthorityFlag("View/EditRole") && {
                  key: "delete",
                  icon: (
                    <ToolOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete Account</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "Name",
      dataIndex: "allname",
      key: "allname",
      titleType: "Input",
      width: 140,
      align: "center",
      onChange: (e) => tableFilterFn(e, "allname"),
      render: (text) => text,
    },
    {
      title: "Email/Login",
      dataIndex: "email",
      key: "email",
      titleType: "Input",
      width: 160,
      align: "center",
      onChange: (e) => tableFilterFn(e, "email"),
      render: (text) => text,
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      titleType: "Select",
      width: 80,
      align: "center",
      selectOptions: [
        { label: "All", value: "" },
        { label: "Active", value: "1" },
        { label: "Inactive", value: "0" },
      ],
      onChange: handlePressActive,
      render: (text, record) => {
        if (text == null || text === "") return " ";
        const handleClick = () => {
          const newValue = text === 1 ? 0 : 1;
          const statusText = newValue === 1 ? "Active" : "Inactive";
          const currentPage = paginationRef.current.current;
          const currentPageSize = paginationRef.current.pageSize;

          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {" "}
                  {statusText}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            onOk: async () => {
              try {
                await updateActiveStatus(record.accountId, newValue);
                message.success("Status updated successfully");
                console.log("tableHead", tableHeadRef.current);
                // 使用 ref 获取最新的 tableHead
                getTableListFn(
                  currentPage,
                  currentPageSize,
                  tableHeadRef.current,
                );
              } catch (error) {
                message.error("Failed to update status");
              }
            },
            style: {
              top: "40%",
            },
          });
        };

        return text === 1 ? (
          <Tag
            color="green"
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            Active
          </Tag>
        ) : (
          <Tag color="red" style={{ cursor: "pointer" }} onClick={handleClick}>
            Inactive
          </Tag>
        );
      },
    },
    {
      title: "App Active",
      dataIndex: "enableApp",
      key: "enableApp",
      titleType: "Select",
      width: 110,
      align: "center",
      selectOptions: [
        { label: "All", value: "" },
        { label: "Active", value: "1" },
        { label: "Inactive", value: "0" },
      ],
      onChange: (e) => tableFilterFn(e, "enableApp", "Select"),
      render: (text, record) => {
        const { accountId } = record;
        const handleClick = () => {
          const currentPage = paginationRef.current.current;
          const currentPageSize = paginationRef.current.pageSize;

          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {text ? " Inactive" : " Active"}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            style: {
              top: "40%",
            },
            onOk: async () => {
              const response = await http.post(`${api.updateEnableApp}`, {
                accountId,
                enableApp: text ? 0 : 1,
              });
              if (response?.code === "1") {
                message.success("Status updated successfully");
                getTableListFn(
                  currentPage,
                  currentPageSize,
                  tableHeadRef.current,
                );
              }
            },
          });
        };
        return (
          <Tag
            color={text ? "green" : "red"}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            {text ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },

    {
      title: "Role",
      dataIndex: "roleList",
      key: "roleList",
      align: "center",
      width: 200,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "roleName"),
      render: (roleList) => {
        if (!roleList || roleList.length === 0) {
          return " ";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {roleList.map((item, idx) => (
              <Tooltip key={idx} title={item.roleName} className="my-tooltip">
                <div className="supervisor-name">{item.roleName}</div>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      key: "supervisor",
      align: "center",
      width: 100,
      render: (supervisor) => {
        if (!supervisor || !Array.isArray(supervisor)) {
          return <div className="supervisor-empty"></div>;
        }
        const len = 3;
        if (supervisor?.length > len) {
          const title = (
            <div style={{ whiteSpace: "pre-line" }}>
              {supervisor.reduce(
                (acc, cur) => (acc ? `${acc}\n${cur}` : cur),
                "",
              )}
            </div>
          );
          const list = [...supervisor.slice(0, len), "..."];
          console.log(title, "===title");

          return (
            <Flex vertical gap={4} style={{ width: "100%" }}>
              {list.map((name, index) => (
                <Tooltip
                  key={`${name}-${index}`}
                  title={name === "..." ? title : name}
                  // className="supervisor-tooltip-wrapper"
                >
                  <div className="supervisor-name">{name}</div>
                </Tooltip>
              ))}
            </Flex>
          );
        }

        return (
          <Flex vertical gap={4} style={{ width: "100%" }}>
            {supervisor.map((name, index) => (
              <Tooltip
                key={`${name}-${index}`}
                title={name}
                className="supervisor-tooltip-wrapper"
              >
                <div className="supervisor-name">{name}</div>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Old Role",
      dataIndex: "oldRoleStr",
      key: "oldRoleStr",
      align: "center",
      width: 100,
    },
    {
      title: "Approval Request View",
      dataIndex: "approvalRequestView",
      key: "approvalRequestView",
      width: 100,
      align: "center",
    },
    {
      title: "Check Approval Level2",
      dataIndex: "checkApprovalLevel2",
      key: "checkApprovalLevel2",
      align: "center",
      width: 100,
    },
    {
      title: "Check Approval Level1",
      dataIndex: "checkApprovalLevel1",
      key: "checkApprovalLevel1",
      align: "center",
      width: 100,
      inputRef: "city",
    },
    {
      title: "Company",
      dataIndex: "companyList",
      key: "companyList",
      align: "center",
      width: 100,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "companyName"),
      render: (companyList) => {
        if (!companyList || companyList.length === 0) {
          return " ";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {companyList.map((item, idx) => (
              <Tooltip key={idx} title={item.companyName}>
                <Tag
                  color="blue"
                  // bordered={false}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.companyCode}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Owner",
      dataIndex: "ownerList",
      key: "ownerList",
      align: "center",
      width: 100,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "ownerName"),
      render: (ownerList) => {
        if (!ownerList || ownerList.length === 0) {
          return " ";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {ownerList.map((item, idx) => (
              <Tooltip key={idx} title={item.ownerCode}>
                <Tag
                  color="cyan"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.ownerCode}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Trust",
      dataIndex: "trustList",
      key: "trustList",
      align: "center",
      width: 100,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "trustName"),
      render: (trustList) => {
        if (!trustList || trustList.length === 0) {
          return " ";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {trustList.map((item, idx) => (
              <Tooltip key={idx} title={item.trustName}>
                <Tag
                  color="orange"
                  // bordered={false}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.trust}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Group",
      dataIndex: "groupNameList",
      key: "groupNameList",
      align: "center",
      width: 100,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "groupName"),
      render: (groupNameList) => {
        if (!groupNameList || groupNameList.length === 0) {
          return " ";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {groupNameList.map((item, idx) => (
              <Tooltip key={idx} title={item.groupName}>
                <Tag
                  color="purple"
                  // bordered={false}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.groupCode}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Prop",
      dataIndex: "propList",
      key: "propList",
      align: "center",
      width: 100,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "propName"),
      render: (propList) => {
        if (!propList || propList.length === 0) {
          return " ";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {propList.map((item, idx) => (
              <Tooltip key={idx} title={item.propName}>
                <Tag
                  color="magenta"
                  // bordered={false}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.prop}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  //Action
  const handleMenuClick = async (e, record) => {
    if (e.key === "reset") {
      setCurrentRecord(record);
      pswModalRef.current?.setModelReset(true, record);
    }

    if (e.key === "update") {
      updateModalRef.current?.showModal(record);
    }
    if (e.key === "delete") {
      Modal.confirm({
        title: "Complete Request",
        icon: <ExclamationCircleOutlined />,
        content: <span>Are you sure to delete this account?</span>,
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          const response = await http.get(api.delAccount, {
            params: { accountId: record.accountId },
          });
          if (response.code === "1") {
            message.success("Successfully delete.");
            getTableListFn(
              paginationRef.current.current,
              paginationRef.current.pageSize,
              tableHeadRef.current,
            );
          }
        },
        style: {
          top: "40%",
        },
      });
    }
  };

  // 修改active 状态
  const updateActiveStatus = async (accountId, activeValue) => {
    try {
      const params = {
        accountId,
        active: activeValue,
      };
      const response = await http.post(`${api.getUpdateAccountStatus}`, params);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const { confirm } = Modal;
  useEffect(() => {
    getTableListFn(pagination.current, pagination.pageSize);
  }, []);

  //列表
  const getTableListFn = async (
    page = pagination.current,
    pageSize = pagination.pageSize,
    params = tableHead,
  ) => {
    setTableLoading(true);
    try {
      const queryParams = {
        page,
        count: pageSize,
        email: params?.email || "",
        enableApp: params?.enableApp || "",
        active: params?.active || "",
        allname: params?.allname || "",
        roleName: params?.roleName || "",
        companyName: params?.companyName || "",
        ownerName: params?.ownerName || "",
        trustName: params?.trustName || "",
        groupName: params?.groupName || "",
        propName: params?.propName || "",
      };

      const response = await http.post(`${api.getAccountPage}`, queryParams);
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.accountId,
      }));

      setTableList(dataWithKey);
      setFilteredData(dataWithKey);

      // 更新分页信息
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total || 0,
        pageSize: pageSize,
      }));
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleRoleUpdateSuccess = () => {
    getTableListFn(pagination.current, pagination.pageSize);
  };
  // 每次 pagination 改变时同步 Ref// 更新 ref 当 tableHead 变化时
  useEffect(() => {
    paginationRef.current = pagination;
    tableHeadRef.current = tableHead;
  }, [pagination, tableHead]);

  // 处理分页变化
  const handleTableChange = (newPagination, filters, sorter, extra) => {
    if (extra.action === "paginate") {
      // 分页变化时更新当前页码
      getTableListFn(newPagination.current, newPagination.pageSize, tableHead);
    } else if (extra.action === "sort") {
      // 排序变化时回到第一页
      getTableListFn(1, newPagination.pageSize, tableHead);
    }
  };
  return (
    <div>
      <Table
        loading={tableLoading}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={{
          showQuickJumper: true,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          showTotal: (total) => {
            return `Total: ${total} items`;
          },
        }}
        rowKey="accountId" // 唯一标识
        onChange={handleTableChange} // 分页、排序、筛选变化时触发
        scroll={{
          x: "max-content", //横向滚动宽度
          y: "calc(100vh - 300px)", //纵向滚动高度
        }}
        className="my-Table"
      />

      <AddModal ref={addModalRef} onSuccess={handleRoleUpdateSuccess} />
      <PswModal
        ref={pswModalRef}
        record={currentRecord}
        onSuccess={handleRoleUpdateSuccess}
      />
      <RoleModal ref={roleModalRef} onSuccess={handleRoleUpdateSuccess} />
      <UpdateModal ref={updateModalRef} onSuccess={handleRoleUpdateSuccess} />
    </div>
  );
});
export default MainTable;
